import React from 'react';

//import { ReportState } from '../types/state';
import { AnyAction } from 'redux';
//import { ReportActionTypes } from '../actions/reports';
//import { AUTH_ACTIONS } from '../actions/auth';

import NavIcon from '../components/ReportsV1/Navigation/NavIcon';

import { ReportsState as IState } from './../types/state';

/*
interface IReports {
  state: IState;
  dispatch: ({
    type,
  }: {
    type: string;
    cardID?: number;
    subcardID?: number | null;
    subAction?: string;
    placement?: string;
    keyword?: string;
  }) => void;
}
*/

export const initialState: IState = {
  filters: [
    {
      id: 1,
      name: 'All reports',
      icon: <NavIcon icon="esg" />,
    },
    /*
    {
      id: 2,
      name: 'Collections',
      icon: <NavIcon icon="position" />,
    },
    */
  ],
  navigationData: [
    {
      id: 1,
      name: 'ESG',
      icon: <NavIcon icon="esg" />,
      options: ['downloadPDF', 'downloadCSV'],
      isOpen: false,
      subcards: [
        {
          id: 1,
          name: 'What is our Social Inclusion score',
          options: ['downloadPDF', 'downloadCSV'],
        },
        {
          id: 2,
          name: 'What percentage of salary are your residents spending on rent?',
          options: ['downloadPDF', 'downloadCSV'],
        },
        {
          id: 3,
          name: 'Multiple Pages',
          options: ['downloadPDF', 'downloadCSV'],
        },
      ],
      category: 1,
    },
    {
      id: 2,
      name: 'Default',
      icon: <NavIcon icon="default" />,
      options: ['downloadPDF', 'downloadCSV'],
      isOpen: false,
      subcards: [],
      category: 1,
    },
    {
      id: 3,
      name: 'Lease',
      icon: <NavIcon icon="esg" />,
      options: ['downloadPDF', 'downloadCSV'],
      isOpen: false,
      subcards: [
        {
          id: 1,
          name: 'Lease Default',
          options: [],
        },
      ],
      category: 1,
    },
  ],
  navState: {
    downloadPDF: {
      state: false,
      cardID: 1,
      subcardID: 2,
    },
    selectedDate: 1,
    selectedCard: 2,
    selectedSubcard: 0,
    selectedCategory: 1,
    filterKeyword: '',
    selectedOptionMenu: {
      cardID: null,
      subcardID: null,
      placement: null,
    },
  },
};

export const reportsReducer = (
  state: IState = initialState,
  action: AnyAction
) => {
  let navState = { ...state.navState };
  let navItems = [...state.navigationData];
  switch (action.type) {
    case 'filterByKeyword':
      navState.filterKeyword = action.payload.keyword;
      return { ...state, navState: navState };
    case 'changeYear':
      navState.selectedDate = action.payload.year;
      return { ...state, navState: navState };
    case 'changeCategory':
      navState.selectedCategory = action.payload.cardID;
      return { ...state, navState: navState };
    case 'changeCard':
      navState = { ...state.navState };
      navState.selectedCard = action.payload.cardID;
      navState.selectedSubcard = action.payload.subcardID;
      if (action.payload.subcardID === null) {
        state.navigationData.forEach((item, key) => {
          if (item.id === action.payload.cardID) {
            if (item.subcards.length > 0) {
              navState.selectedSubcard = item.subcards[0].id;
            }
          }
        });
      }
      return { ...state, navState: navState, navItems };
    case 'hideNavOptions':
      navState = { ...state.navState };
      navState.selectedOptionMenu.cardID = null;
      navState.selectedOptionMenu.subcardID = null;
      navState.selectedOptionMenu.placement = null;
      return { ...state, navState: navState };
    case 'openNavOptions':
      navState = { ...state.navState };
      navState.selectedOptionMenu.cardID = action.payload.cardID;
      navState.selectedOptionMenu.subcardID = action.payload.subcardID;
      navState.selectedOptionMenu.placement = action.payload.placement;

      return { ...state, navState: navState };
    case 'downloadSuccess':
      navState = { ...state.navState };
      navState.downloadPDF.state = false;
      return { ...state, navState: navState };
    case 'navItemOption':
      navState = { ...state.navState };
      navState.downloadPDF.state = true;
      navState.downloadPDF.cardID = action.payload.cardID;
      navState.downloadPDF.subcardID = action.payload.subcardID;
      return { ...state, navState: navState };
    case 'fetchDefaultNavigation':
      navItems[1].subcards = [
        {
          id: 0,
          name: 'Default',
          // description: item.description,
          // options: [],
        },
      ].concat(...action.payload);
      return { ...state, navigationData: navItems };
    default:
      return state;
  }
};

export default reportsReducer;

/*    
    case ReportActionTypes.IS_LOADING: {
      return Object.assign({}, state, { isLoading: action.payload });
    }
    case ReportActionTypes.AVAILABLE_REPORTS_DATA: {
      return Object.assign({}, state, { reportData: action.payload });
    }
    case ReportActionTypes.PREV_OFFER_DATA: {
      const { offer_cycle, data } = action.payload;
      return Object.assign({}, state, {
        prevOfferData: { ...state.prevOfferData, ...data },
        downloadReady: offer_cycle,
      });
    }
    case ReportActionTypes.EXEC_SUMMARY_URL: {
      let { url } = action.payload;
      return Object.assign({}, state, { execDownloadUrl: url });
    }
    case ReportActionTypes.OVERRIDE_REPORT_DATA: {
      let { offer_cycle, data } = action.payload;
      return Object.assign({}, state, {
        overrideData: { [offer_cycle]: data },
        downloadOverrideReady: offer_cycle,
      });
    }
    case ReportActionTypes.DATA_DOWNLOAD_FLAG: {
      return Object.assign({}, state, { downloadReady: action.payload });
    }
    case ReportActionTypes.OVERRIDE_DATA_DOWNLOAD_FLAG: {
      return Object.assign({}, state, {
        downloadOverrideReady: action.payload,
      });
    }
    case AUTH_ACTIONS.LOGOUT: {
      return initialState;
    }
  */
